import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import '../src/i18n';
import App from './App';
import { getEnv } from './env';

const apiKey = getEnv('REACT_APP_STREAM_KEY');
const urlParams = new URLSearchParams(window.location.search);
const user = urlParams.get('user') || process.env.REACT_APP_USER_ID;
const userToken = urlParams.get('user_token') || process.env.REACT_APP_USER_TOKEN;
const targetOrigin = urlParams.get('target_origin') || getEnv('REACT_APP_TARGET_ORIGIN');

const userToConnect: { id: string | undefined } = { id: user };

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container!);
root.render(
  <React.StrictMode>
    <App
      apiKey={apiKey!}
      userToConnect={userToConnect}
      userToken={userToken}
      targetOrigin={targetOrigin!}
    />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
